import React, { useState } from 'react';
import NextImage, { StaticImageData } from 'next/image';

import {
    Container,
    HiddenLink,
    ImageWrapper,
    SmallWeekCalendar,
    StyledWeekCalendar,
    WeekStatus,
    ContentWrapper,
    HeadingWrapper,
    PhoneWeekStatus,
    Heading,
    CardLink,
    Description
} from './FiftyTwoWeeks.styled';

export interface Props {
    heading: string;
    image: {
        src: StaticImageData | string;
        alt?: string;
    };
    calendarColour: string;
    weekStatus?: {
        status: string;
        colour: string;
    };
    week: number;
    description: string;
    href: string;
    className?: string;
}

const FiftyTwoWeeks: React.FC<Props> = props => {
    const { heading, image, calendarColour, weekStatus, week, description, href, className } =
        props;
    const [isHovering, setIsHovering] = useState(false);

    return (
        <Container className={className}>
            <HiddenLink
                href={href}
                tabIndex={-1}
                aria-hidden={true}
                onMouseOver={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
            />
            <ImageWrapper $weekStatus={weekStatus?.status} $isHovering={isHovering}>
                <SmallWeekCalendar week={week} color={calendarColour} />
                {weekStatus && (
                    <WeekStatus $weekStatusColour={weekStatus.colour}>
                        {weekStatus.status}
                    </WeekStatus>
                )}
                <NextImage
                    src={image.src}
                    alt={image.alt || ''}
                    fill
                    style={{ objectFit: 'cover', borderRadius: '0.375rem' }}
                />
            </ImageWrapper>
            <ContentWrapper $isHovering={isHovering}>
                <HeadingWrapper $isHovering={isHovering}>
                    <StyledWeekCalendar week={week} color={calendarColour} />
                    {weekStatus && (
                        <PhoneWeekStatus $weekStatusColour={weekStatus.colour}>
                            {weekStatus.status}
                        </PhoneWeekStatus>
                    )}
                    <Heading>
                        <CardLink
                            href={href}
                            aria-label={`Read more about: ${heading}`}
                            data-hover={isHovering}
                            onFocus={() => setIsHovering(true)}
                            onBlur={() => setIsHovering(false)}
                            onMouseOver={() => setIsHovering(true)}
                            onMouseLeave={() => setIsHovering(false)}
                        >
                            {heading}
                        </CardLink>
                    </Heading>
                </HeadingWrapper>
                <Description aria-hidden={!isHovering} $isHovering={isHovering}>
                    {description}
                </Description>
            </ContentWrapper>
        </Container>
    );
};

export default FiftyTwoWeeks;
